
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topics/[slugCategory]",
      function () {
        return require("private-next-pages/topics/[slugCategory]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topics/[slugCategory]"])
      });
    }
  